(function () {
    'use strict';

    var serviceId = 'searchParserService';

    angular.module('app.common')
        .factory(serviceId, ['$rootScope', '$state', 'locatorService', '$q', 'yandexReverseGeocode', '$window', 'parcelClientService', '$translate', '$ocLazyLoad', searchParserService]);

    function searchParserService($rootScope, $state, locatorService, $q, yandexReverseGeocode, $window, parcelClientService, $translate, $ocLazyLoad) {
        var obj = {
            parseSearchForController: parseSearchForController,
            parseSearch: parseSearch,
            useLocation: useLocation,
            useCity: useCity,
            storeAddress: storeAddress,
            parseSearchForOpportunity: parseSearchForOpportunity,
            centerInPoly: centerInPoly,
            rawAddress: ""
        };

        return obj;


        function parseSearchForOpportunity(opport) {
            var deferred = $q.defer();
            var location;
            if (opport.GeoLocation)
                location = opport.GeoLocation.Latitude.toString().replace('.', ',') + ";" + opport.GeoLocation.Longitude.toString().replace('.', ',');
            else
                location = opport.Latitude.toString().replace('.', ',') + ";" + opport.Longitude.toString().replace('.', ',');
            $rootScope.address = location;
            deferred.resolve(location);
            // locatorService.setPoint($rootScope.address, params).then(function (res) {
            //     deferred.resolve(res);
            // });
            return deferred.promise;
        }

        function parseSearchForController(params, transition) {
            var deferred = $q.defer();
            // var address;
            var storedLang = $window.lang || 'en';

            if (params.address &&
                !params.country &&
                !params.province &&
                !params.county &&
                !params.neighbourhood &&
                !params.block &&
                !params.parcel) {
                // address = angular.copy(params.address);
                // if ($rootScope.address !== address)
                //     $rootScope.address = address;
                if ($rootScope.address && isNaN($rootScope.address) && !params.address)
                    locatorService.setPoint($rootScope.address, params).then(function (res) {
                        deferred.resolve(res);
                    }, function () {
                        transition.abort();
                        transition.router.stateService.go("404", { langcode: storedLang });
                    });
                else if ((!$rootScope.address || isNaN($rootScope.address)) && params.address)
                    locatorService.setPoint(params.address, params).then(function (res) {
                        deferred.resolve(res);
                    }, function () {
                        transition.abort();
                        transition.router.stateService.go("404", { langcode: storedLang });
                    });
                else if ($rootScope.address)
                    parcelClientService.getParcelInfoByPropertyId($rootScope.address).then(function (result) {
                        // $rootScope.address = result.data.center[1].toString().replace('.', ',') + ';' + result.data.center[0].toString().replace('.', ',');
                        locatorService.setPoint($rootScope.address, params).then(function (res) {
                            deferred.resolve(res);
                        }, function () {
                            transition.abort();
                            transition.router.stateService.go("404", { langcode: storedLang });
                        });
                    });
                else {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                }
                //country
            }
            else if (params.country && !params.province && !params.county && !params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointCountry(params.country).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
                //province
            }
            else if (params.country && params.province && !params.county && !params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointProvince(params.country, params.province).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
                //county
            } else if (params.country && params.province && params.county && !params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointCounty(params.country, params.province, params.county).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            } else if (params.country && params.province && params.county && params.neighbourhood && !params.block && !params.parcel) {
                locatorService.setPointNeighbourhood(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' ')).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            }
            else if (params.country && params.province && params.county && params.neighbourhood && params.block && !params.parcel) {
                var resolver = isSpain(params.country) ?
                    locatorService.setPointSpanishNeighbourhood(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' '), params.block.replaceAllString('-', ' ')) :
                    locatorService.setPointBlock(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' '), params.block);
                resolver.then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            }
            else if (params.country && params.province && params.county && params.neighbourhood && params.block && params.parcel) {
                locatorService.setPointParcel(params.country, params.province, params.county, params.neighbourhood.replaceAllString('-', ' '), params.block, params.parcel).then(function (res) {
                    deferred.resolve(res);
                }, function () {
                    transition.abort();
                    transition.router.stateService.go("404", { langcode: storedLang });
                });
            }
            return deferred.promise;
        }

        function useCity(isLanding, city, actionType) {
            var currentstate = $window.localStorage.getItem('currentState');
            var stateProp = currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

            if ($rootScope.country === 'world' || city === 'city-district' || city === 'sehir' || city === 'distrito') {
                // if (isLanding)
                //     $rootScope.actionType($rootScope.country);
                // else
                if (actionType === 20)
                    $state.go('analysis.country.agents', { country: $rootScope.country, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });      
                else if (actionType === 30)
                    $state.go('analysis.country.investment', { country: $rootScope.country, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else if (!isLanding)
                    $state.go('analysis.country.' + stateProp, { country: $rootScope.country, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else
                    $state.go('valuation-wrapper', { langcode: $window.lang });
            }
            else {
                // if (isLanding)
                //     $rootScope.actionType($rootScope.country, city);
                // else
                if (actionType === 20)
                    $state.go('analysis.province.agents', { country: $rootScope.country, province: city, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
               
                else if (actionType === 30)
                    $state.go('analysis.province.investment', { country: $rootScope.country, province: city, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else if (!isLanding)
                    $state.go('analysis.province.' + stateProp, { country: $rootScope.country, province: city, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                else
                    $state.go('valuation-wrapper', { langcode: $window.lang });
            }

        }

        function useLocation(isLanding, actionType) {
            if (navigator.geolocation) {
                $window.gatheredLocation = null;
                $window.selectedLocation = null;
                $rootScope.address = undefined;
                navigator.geolocation.getCurrentPosition(function (position) {
                    if (position) {
                        var location = position.coords.latitude.toString().replace('.', ',') + ";" + position.coords.longitude.toString().replace('.', ',');
                        yandexReverseGeocode.geocodeLatlng(position.coords.latitude, position.coords.longitude).then(function (formattedAdres) {
                            formattedAdres = formattedAdres.replace(', Türkiye', '').replaceAllString(',', '').replaceAllString(':', ' ').replace(/\./g, '').replaceAllString('/', ' ');
                            $rootScope.address = formattedAdres;
                        });
                        if (actionType && actionType === 20)
                            $state.go('analysis.address.agents', { langcode: $window.lang, address: location});
                        else if (actionType && actionType === 30)
                            $state.go('analysis.address.investment', { langcode: $window.lang, address: location});            
                        else if (isLanding)
                            $state.go('valuation-wrapper', { langcode: $window.lang, address: location });
                        else {
                            //get LanguageKey
                            var currentstate = $window.localStorage.getItem('currentState');
                            var stateProp = currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

                            $state.go('analysis.address.' + stateProp, { address: location, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), langcode: $rootScope.lang });
                        }

                    }
                }, function () { }, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                });
            }
            return false;
        }

        function checkSurroundingStates(state) {
            if (state === 'education' || state === 'transportation' || state === 'health' || state === 'life' || state === 'entertainment')
                return 'value';
            else
                return state;
        }

        function centerInPoly(latlon) {
            if ($window.parcelRecord) {
                //Turf çok büyük bir paket gereksiz yere yüklemeyelim
                $ocLazyLoad.load('/assets/js/turf.min.js').then(function () {
                    var pt = turf.point([latlon.lon, latlon.lat]);
                    var isCenterInPoly = turf.booleanPointInPolygon(pt, $window.parcelRecord.geo);
                    // is it in the polygon
                    if (!isCenterInPoly) {
                        latlon.lat = $window.parcelRecord.geo.geometry.coordinates[0][0][1];
                        latlon.lon = $window.parcelRecord.geo.geometry.coordinates[0][0][0];
                    }
                });
            }

            return latlon;
        }

        function parseSearch(redirect, listing, force, opType, isLanding) {
            var direction = $rootScope.address;
            direction = direction ? direction : ($rootScope.country === 'turkiye') ? 'Türkiye' : undefined;
            $window.lastLevel = $window.lastLevel || $window.lastLevel === 0 ? $window.lastLevel : (force ? 9 : undefined);



            //TODO hata mesajı çıkarılabilir.
            if (!direction && !$window.parcelRecord) {
                return "";
            }

            if (direction) {
                direction = direction.replaceAllString(":", " ");
                direction = direction.replace(/\./g, '');
                direction = removeDiacritics(direction);
                direction = direction.toLowerCase();
            }

            // get LanguageKey
            var langKey = $window.lang || 'tr';
            var currentstate = $window.localStorage.getItem('currentState');
            var stateProp = listing ? listing : currentstate && currentstate.split('.')[2] ? currentstate.split('.')[2] : 'value';

            stateProp = checkSurroundingStates(stateProp);
            if (stateProp === 'comparables' && $window.lastLevel !== 8 && $window.lastLevel !== 0 )
                stateProp = 'value'

            //projectid is here
            if ($window.projectId && !listing) {
                if (redirect)
                    $state.go('project-detail', { langcode: langKey, id: $window.projectId, name: normalizeAddress(direction) });
                else
                    return $state.href('project-detail', { langcode: langKey, id: $window.projectId, name: normalizeAddress(direction) });
            }
            //endeksaid is here
            else if ($window.endeksaId && !listing) {
                if (redirect)
                    $state.go('property-detail', { langcode: langKey, id: $window.endeksaId, name: normalizeAddress(direction) });
                else
                    return $state.href('property-detail', { langcode: langKey, id: $window.endeksaId, name: normalizeAddress(direction) });
            }
            else if ($window.agentId && !listing) {
                var adr = normalizeAddress(direction);
                var name = adr.split('-')[0] + '-' + adr.split('-')[1];
                if (redirect)
                    $state.go('agent-detail', { langcode: langKey, path: ($rootScope.lang === 'tr' ? 'danisman' : 'agents'), id: $window.agentId, name: name });
                else
                    return $state.href('agent-detail', { langcode: langKey, path: ($rootScope.lang === 'tr' ? 'danisman' : 'agents'), id: $window.agentId, name: name });
            }
            //opport is here
            else if ($window.opportId && !listing) {
                var PortfolioId = $window.opportId.split('-')[0];
                var PropertyCategory = +$window.opportId.split('-')[1];
                var PropertyType = $window.opportId.split('-')[2];

                var CityName = direction.split(', ')[3];
                var CountyName = direction.split(', ')[2];
                // var DistrictName = direction.split(', ')[1];
                var Name = direction.split(', ')[0];

                var ev =
                    PropertyCategory === 2 ?
                        $translate.instant("ticari") : PropertyCategory === 3 ?
                            $translate.instant("arsa") : PropertyType === 'null' ?
                                $translate.instant("konut") :
                                +PropertyType === 10 ?
                                    $translate.instant("daire") :
                                    $translate.instant("mustakil-ev");

                var name = normalizeAddress(CityName + "-" + CountyName + "-" + Name) + "-" + $translate.instant("satilik") + "-" + ev;
                if (redirect) {
                    $state.go('localInfo.property', { langcode: langKey, name: name, id: PortfolioId });
                }
                else {
                    return $state.href('localInfo.property', { langcode: langKey, name: name, id: PortfolioId });
                }
            }
            //mallid is here
            else if ($window.mallId && !listing) {
                if (redirect)
                    $state.go('mall-detail', { langcode: langKey, id: $window.mallId, name: normalizeAddress(direction) });
                else
                    return $state.href('mall-detail', { langcode: langKey, id: $window.mallId, name: normalizeAddress(direction) });
            }
            //go to province
            else if ($window.regionId) {
                var region = 'reg-' + $window.regionId;
                if (redirect)
                    $state.go('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: region, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: region, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }
            //go to province
            else if ($window.lastLevel === 9 || $window.lastLevel === 10) {
                if (redirect)
                    $state.go('analysis.country.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.country.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }

            //go to province
            else if ($window.lastLevel === 1) {
                var il = direction.indexOf(',') !== -1 ? direction.split(',')[0] : direction;
                if (redirect)
                    $state.go('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.province.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }

            //go to county
            else if ($window.lastLevel === 2 && direction.split(',')[1]) {
                var il = direction.split(',')[1].trim();
                var ilce = direction.split(',')[0].trim();
                if (redirect)
                    $state.go('analysis.county.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.county.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }

            //go to neighboor
            else if ($window.lastLevel === 3 && direction.split(',')[1]) {
                var il, ilce, mah;
                var splited = direction.split(',');
                if (splited.length > 3) {
                    il = splited[3].trim();
                    ilce = splited[2].trim();
                } else if (splited.length > 2) {
                    il = splited[2].trim();
                    ilce = splited[1].trim();
                } else if (splited.length > 1) {
                    il = splited[1].replace(' merkez', '').trim();
                    ilce = 'merkez';
                }

                mah = splited[0].trim();
                mah = mah.replace(' semti', '');
                mah = mah.replace(' mh', '');
                mah = mah.replace(' mahallesi', '');
                mah = mah.replace(' mah', '');
                mah = mah.replaceAllString(' ', '-');

                if (isSpain($rootScope.country) && splited.length > 3) {
                    var quarter = splited[1].trim().replaceAllString(' ', '-');
                    if (redirect)
                        $state.go('analysis.block.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: quarter, block: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                    else
                        return $state.href('analysis.block.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: quarter, block: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                }
                else if (redirect)
                    $state.go('analysis.neighbourhood.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
                else
                    return $state.href('analysis.neighbourhood.' + stateProp, { langcode: langKey, country: $rootScope.country, province: il, county: ilce, neighbourhood: mah, satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut) });
            }
            else if ($window.gatheredLocation) {
                var cLat = +$window.gatheredLocation.split(' ')[0];
                var cLon = +$window.gatheredLocation.split(' ')[1]
                $ocLazyLoad.load('/assets/js/turf.min.js').then(function () {

                    var pt = turf.point([cLat, cLon]);

                    if ($window.parcelRecord) {
                        var isCenterInPoly = turf.booleanPointInPolygon(pt, $window.parcelRecord.geo);
                        // is it in the polygon
                        if (!isCenterInPoly)
                            $window.gatheredLocation = ($window.parcelRecord.geo.geometry.coordinates[0][0][0]).toString() +
                                ' ' + ($window.parcelRecord.geo.geometry.coordinates[0][0][1]).toString();
                    }

                    if ($window.rememberProperty) {
                        if ($window.rememberProperty.PropertyCategory === 2) {
                            $rootScope.konut = $translate.instant('ticari');
                        } else if ($window.rememberProperty.PropertyCategory === 3) {
                            $rootScope.konut = $translate.instant('arsa');
                        } else {
                            $rootScope.konut = $translate.instant('konut');
                        }

                        if ($window.rememberProperty.PropertyPriceType === 1) {
                            $rootScope.satilik = $translate.instant('satilik');
                        } else {
                            $rootScope.satilik = $translate.instant('kiralik');
                        }
                    }
                    else if ($window.parcelRecord && $window.parcelRecord.data) {
                        var nitelik = $window.parcelRecord.data.nitelik.toLowerCase();
                        if (nitelik.indexOf('tarla') > -1 || nitelik.indexOf('bahçe') > -1 || nitelik.indexOf('çayır') > -1 || nitelik.indexOf('arazi') > -1 || nitelik.indexOf('zeytinlik') > -1) {
                            $rootScope.konut = $translate.instant('arazi');
                            $window.lastestCategory = 3;
                            $window.lastestType = 2;
                            $rootScope.satilik = $translate.instant('satilik');
                        }
                        else if (nitelik.indexOf('arsa') > -1) {
                            $rootScope.konut = $translate.instant('arsa');
                            $window.lastestCategory = 3;
                            $window.lastestType = 1;
                            $rootScope.satilik = $translate.instant('satilik');
                        }
                        else if (nitelik.indexOf('ticari') > -1) {
                            $rootScope.konut = $translate.instant('ticari');
                            $window.lastestCategory = 2;
                            $window.lastestType = 5;
                            $rootScope.satilik = $translate.instant('satilik');
                        }
                        else {
                            $rootScope.konut = $translate.instant('konut');
                            $window.lastestCategory = 1;
                            $window.lastestType = 4;
                        }
                    }

                    var lat = $window.gatheredLocation.split(' ')[1];
                    var lng = $window.gatheredLocation.split(' ')[0];
                    if (opType === 20)
                        if (redirect)
                            $state.go('analysis.province.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                        else
                            return $state.href('analysis.province.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                    else
                        if (redirect)
                            $state.go('analysis.address.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                        else
                            return $state.href('analysis.address.' + stateProp, { langcode: langKey, address: lat.replace('.', ',') + ';' + lng.replace('.', ','), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                });
            } else {
                // if (isLanding) {
                //     $rootScope.actionType($rootScope.country, null, null, null, normalizeAddress(direction));
                // }
                // else
                if (redirect)
                    $state.go('analysis.address.' + stateProp, { langcode: langKey, address: normalizeAddress(direction), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
                else
                    return $state.href('analysis.address.' + stateProp, { langcode: langKey, address: normalizeAddress(direction), satilik: $translate.instant($rootScope.satilik), konut: $translate.instant($rootScope.konut), le: ($window.lastLevel === 5 ? $window.lastLevel : null) });
            }
        }

        // function parseSearchForRenta() {
        //     var direction = $rootScope.address;

        //     //TODO hata mesajı çıkarılabilir.
        //     if (!direction && !$window.parcelRecord) {
        //         return "";
        //     }

        //     direction = direction.replaceAllString(":", " ");
        //     direction = direction.replace(/\./g, '');
        //     direction = removeDiacritics(direction);
        //     direction = direction.toLowerCase();

        //     // get LanguageKey
        //     var langKey = window.lang || 'tr';

        //     return $state.href('renta', { langcode: langKey, address: normalizeAddress(direction) });
        // }

        function storeAddress(addr) {
            obj.rawAddress = addr;
        }

        function isSpain(country) {
            return +country === 2 || normalizeAddress(country) === 'espana';
        }
    }
})();